module.exports = __webpack_public_path__ + "static/media/frame_06.32d4ce3b.png";